module.exports = __webpack_public_path__ + "static/media/ic_STC-pay.41f60195.svg";